import React from "react";
import homeSection01Img from "@/shared/assets/img/home-sec01-01.png";
import homeSection01Card01 from "@/shared/assets/img/home-sec01-card01.png";
import homeSection01Card02 from "@/shared/assets/img/home-sec01-card02.png";
import homeSection01Card03 from "@/shared/assets/img/home-sec01-card03.png";
import { ReactComponent as Character01 } from "@/shared/assets/svg/character01.svg";
import { ReactComponent as Character02 } from "@/shared/assets/svg/character02.svg";
import { ReactComponent as Pencil } from "@/shared/assets/svg/pencil01.svg";
import book01 from "@/shared/assets/img/book01.png";

/**
 * Section1 - AI Learning Friend
 * Displays 3 main learning apps/features
 */
export const Section1: React.FC = () => {
  const apps = [
    {
      id: 1,
      image: homeSection01Card01,
      title: "쏙쏙 한글",
    },
    {
      id: 2,
      image: homeSection01Card02,
      title: "톡톡 영어",
    },
    {
      id: 3,
      image: homeSection01Card03,
      title: "척척 수학",
    },
  ];

  return (
    <section
      className="w-full bg-white py-16 lg:py-20"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Header with Image */}
        <div className="mb-12 lg:mb-16 flex justify-center">
          <img
            src={homeSection01Img}
            alt="AI 학습 친구"
            className="w-96 h-24 rounded-2xl lg:rounded-3xl object-contain"
          />
        </div>

        {/* App Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative pt-20">
          {apps.map((app, index) => (
            <div key={app.id} className="relative rounded-3xl flex flex-col">
              {/* Character on first card */}
              {index === 0 && (
                <div className="absolute -top-16 left-24 transform -translate-x-1/2 w-40 h-36 z-20">
                  <Character01 className="w-20 h-20" />
                </div>
              )}

              {/* Book icon on first card */}
              {index === 0 && (
                <div className="absolute -top-12 right-32 w-20 h-12 z-20">
                  <img src={book01} alt="Book Icon" className="w-full h-full" />
                </div>
              )}

              {/* Character02 on third card - hidden on mobile */}
              {index === 2 && (
                <div className="absolute top-8 -right-36 w-48 h-40 z-20 hidden lg:block">
                  <Character02 className="w-full h-full" />
                </div>
              )}

              {/* Pencil on third card - hidden on mobile */}
              {index === 2 && (
                <div className="absolute -bottom-0 -right-8 w-16 h-24 z-0 hidden lg:block">
                  <Pencil className="w-full h-full" />
                </div>
              )}

              {/* Card Image - overflow hidden only on image */}
              <div
                className="overflow-hidden rounded-t-3xl"
                style={{ zIndex: 10 }}
              >
                <img
                  src={app.image}
                  alt={app.title}
                  className="w-full h-auto object-cover"
                />
              </div>

              {/* Card Title */}
              {/* <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 lg:p-6 rounded-b-3xl flex items-center justify-center">
                <h3 className="text-white text-xl lg:text-2xl font-extrabold font-['NanumSquareRoundOTF']">
                  {app.title}
                </h3>
              </div> */}
            </div>
          ))}
        </div>

        {/* Description Section */}
        <div className="mt-12 lg:mt-16 text-center">
          <p className="text-xl lg:text-2xl font-bold font-['NanumSquareRoundOTF'] text-black leading-relaxed">
            기초부터 심화학습을 통해
            <br />
            <span className="text-orange-500 font-extrabold">
              [문해력+수해력+사고력]
            </span>
            <br />을 키워 교육과정 학습을 준비합니다.
          </p>
        </div>

        {/* CTA Section */}
        <div className="mt-12 lg:mt-16 flex justify-center">
          <button className="bg-orange-500 text-white px-8 py-3 rounded-full font-bold font-['NanumSquareRoundOTF'] hover:bg-orange-600 transition-colors">
            자세히 보기
          </button>
        </div>
      </div>
    </section>
  );
};
